import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const reorderEntries: YJSChangeHandler<DatabaseChangeType.REORDER_ENTRIES> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    db.reorderEntries(change.entryIds, change.newIndex);
  });
};
